import { PresetViewSupportedView, type PresetView } from '@bringg/types';

import { TasksPresetView, AlertsPresetView } from '../stores';

function map(presetView: PresetView) {
	return {
		current:
			presetView.view === PresetViewSupportedView.Dispatch || presetView.view === PresetViewSupportedView.Planning
				? new TasksPresetView(presetView)
				: new AlertsPresetView(presetView)
	};
}

export const presetViewsStoreMapper = { map };
